<div class="">
  <div class="title-modal-personalized modal-header">
    <div
      class="text-centered d-flex align-content-center justify-content-center">
      <h1 class="text-white">
        {{ data.title }}
      </h1>
    </div>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <fa-icon
        class="icon-personalized"
        [icon]="faTriangleExclamation"></fa-icon>
    </div>
    <h4 class="text-wrap text-fixed-personalized mt-2">{{ data.body }}</h4>
  </div>
  <div class="d-flex flex-wrap p-4 justify-content-center align-items-center">
    <div>
      <button
        class="btn btn-primario btn-pequenos"
        style="width: 110px"
        (click)="confirm()">
        <span> Confirmar </span>
      </button>
    </div>
  </div>
</div>
